// extracted by mini-css-extract-plugin
module.exports = {"btn_group":"styles_btn_group__pJHHD","confirm_change_collected":"styles_confirm_change_collected__2CDmB","checked_state":"styles_checked_state__hqXLi"};